var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',[_c('b-form-input',{class:['ui-input', _vm.cls],attrs:{"id":_vm.id,"readonly":true},model:{value:(_vm.displayValue),callback:function ($$v) {_vm.displayValue=$$v},expression:"displayValue"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }